/**
 * These names are given to by the client, do not change.
 */
export enum DirectCallRules {
  NAME_PAGE_VIEW = 'page_view',
  NAME_INITIAL_PAGE_LOAD = 'initial_page_load',
  LOAD_INITIAL = 'load_initial',
  LOAD_MORE = 'load_more',
}
